import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import React from 'react';

export default function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}>
            <Box>{children}</Box>
        </Typography>
    );
}
